<template>
  <header class="">
    <!-- <div class="container">
      <div class="tx-18 text-white">{{ comp.task }}</div>
    </div> -->
    <div class="hero-section">
      <div class="container">
          <h1 class="page-title">{{ comp.task }}</h1>
          <p class="page-subtitle">
              {{ comp.f1 }}
          </p>
      </div>
  </div>
  </header>
</template>

<script>
export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style scoped>
.hero-section {
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://res.gosmart.mn/apps/egazar/cover4.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: grayscale(100%);
  color: white;
  padding: 80px 0 60px;
  text-align: center;
  position: relative;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  color: white;
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.page-subtitle {
  color: white;
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 400px;
  margin: 0 auto;
  text-transform: uppercase;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}
</style>
